// extracted by mini-css-extract-plugin
export default {"wrapper":"Zc","centered":"_c","gridWrapper":"ad","grid":"bd","oneColumn":"cd"};